import React, { PureComponent } from 'react';

import { getRequest } from '../../../../../api/ApiService';

import OneVisualLayout from '../../layouts/one-visual';
import HorizontalBarChart from "../../../../components/charts/horizontal-bar";
import styled from 'styled-components';

const getPercentage = value => (
  value > 0 ? `${(value * 100).toFixed(0)}%` : "---"
);

const colors = [
  '#3A507B',
  '#445982',
  '#4E6288',
  '#586B8F',
  '#617395',
  '#6B7C9C',
  '#7585A3',
  '#9DA8BD'
];

const ChartContainer = styled.div`
  padding: 15px 20px 10px;
  font-family: 'Mukta Vaani';
  position: relative;

  > h3 {
    color: #EA4335;
    font-size: 16px;
    line-height: 16px;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    margin-bottom: 30px;
    font-weight: 700;
  }
`;

const ChartLabel = styled.p`
  font-size: 12px;
  line-height: 15px;
  color: #3A507B;
  font-weight: 600;
  text-align: center;
  margin-top: 15px;

  ${p => p.rotated && `
    transform: rotate(-90deg) translateX(30%);
    position: absolute;
    top: 50%;
    margin-top: 0;
  `}
`;

class ResultsAreInStep1 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      standardTeamGrade: 0
    };
  }

  componentDidMount() {
    const { roundId } = this.props;

    getRequest(`${process.env.REACT_APP_API_URL}v2/games/teamgradings/overall/${roundId}`)
      .then(res => {
        const { standard_deviation } = res.body;

        this.setState({
          standardTeamGrade: standard_deviation
        });
      })
      .catch(err => { });
  }

  render() {
    const { activeRound, teamGradings, teamGradingsLength } = this.props;
    const { standardTeamGrade } = this.state;

    const teamsWithWeightedValue1 = teamGradings.filter(i => Number(i.current_weighted_value) === 1);
    const teamsWithWeightedValue95 = teamGradings.filter(i => (Number(i.current_weighted_value) >= 0.95 && Number(i.current_weighted_value) < 1));
    const teamsWithWeightedValue90 = teamGradings.filter(i => (Number(i.current_weighted_value) >= 0.9 && Number(i.current_weighted_value) < 0.95));
    const teamsWithWeightedValue85 = teamGradings.filter(i => (Number(i.current_weighted_value) >= 0.85 && Number(i.current_weighted_value) < 0.9));
    const teamsWithWeightedValue80 = teamGradings.filter(i => (Number(i.current_weighted_value) >= 0.8 && Number(i.current_weighted_value) < 0.85));
    const teamsWithWeightedValue75 = teamGradings.filter(i => (Number(i.current_weighted_value) >= 0.75 && Number(i.current_weighted_value) < 0.8));
    const teamsWithWeightedValue70 = teamGradings.filter(i => (Number(i.current_weighted_value) >= 0.7 && Number(i.current_weighted_value) < 0.75));
    const teamsWithWeightedValueLess70 = teamGradings.filter(i => Number(i.current_weighted_value) < 0.7);

    const chartData = [
      {
        name: '100%',
        value: teamsWithWeightedValue1.length
      },
      {
        name: '95%',
        value: teamsWithWeightedValue95.length
      },
      {
        name: '90%',
        value: teamsWithWeightedValue90.length
      },
      {
        name: '85%',
        value: teamsWithWeightedValue85.length
      },
      {
        name: '80%',
        value: teamsWithWeightedValue80.length
      },
      {
        name: '75%',
        value: teamsWithWeightedValue75.length
      },
      {
        name: '70%',
        value: teamsWithWeightedValue70.length
      },
      {
        name: 'less than 70%',
        value: teamsWithWeightedValueLess70.length
      }
    ];

    const weightedValuesSum = teamGradings.reduce((accumulator, item) => accumulator + Number(item.weighted_value), 0);
    const averageTeamGrade = weightedValuesSum / teamGradings.length;

    teamGradings.sort((a, b) => a.weighted_value - b.weighted_value);
    const middle = Math.floor(teamGradings.length / 2);
    let medianTeamGrade = 0;
    if (teamGradings.length % 2 === 0) {
      medianTeamGrade = (Number(teamGradings[middle - 1].weighted_value) + Number(teamGradings[middle].weighted_value)) / 2;
    } else {
      medianTeamGrade = Number(teamGradings[middle].weighted_value);
    }

    return (
      <OneVisualLayout
        title={`RESULTS ARE IN! | ROUND ${activeRound} SCORE`}
        paragraph1={(
          <p><b>{teamsWithWeightedValue1.length}</b> out of <b>{teamGradingsLength}</b> teams hit their financial targets for the round. The average team score was {getPercentage(averageTeamGrade)}, the median was {getPercentage(medianTeamGrade)}, and the standard deviation was {getPercentage(standardTeamGrade)}.</p>
        )}
        visual={(
          <ChartContainer>
            <h3>Team Score Distribution</h3>
            <ChartLabel rotated={true}>no. of teams</ChartLabel>
            <HorizontalBarChart
              data={chartData}
              colors={colors}
              height={290}
              xAxisLine={false}
              hideYAxis={false}
              hideXAxis={true}
              xAxisTick={true}
              barSize={50}
              showBarLabel={true}
              showIntegerLabel={true}
            />
            <ChartLabel>Team Score</ChartLabel>
          </ChartContainer>
        )}
        visualProps={{
        }}
      />
    );
  }

}

export default ResultsAreInStep1;


// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/results-are-in/step1.js